import { render, staticRenderFns } from "./GrupoUsuario.vue?vue&type=template&id=3a8e2e14"
import script from "./GrupoUsuario.vue?vue&type=script&lang=js"
export * from "./GrupoUsuario.vue?vue&type=script&lang=js"
import style0 from "./GrupoUsuario.vue?vue&type=style&index=0&id=3a8e2e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports